<template>
    <div class="home-how-it-works-steps-container" v-observe-visibility="onVisibilityChanged">
        <div class="home-how-it-works-steps desktop-only">
            <div class="screens">
                <home-steps-screen-carousel :index="index" />
            </div>
            <div>
                <h2>{{ $t('home.how-it-works') }}</h2>
                <ul class="pills">
                    <li v-for="i in 5" :key="i" @click="navigateTo(i)" :class="{active: i === index}">
                        <span class="order">
                            <span>{{ i }}</span>
                        </span>
                        <span class="step-label" v-html="$t('home.how-it-works-' + i)" />
                    </li>
                </ul>
                <div class="home-how-it-works-stores-container">
                    <p>{{ $t('home.download-app') }}</p>
                    <div class="home-how-it-works-stores">
                        <a href="https://apps.apple.com/us/app/openfly/id1450925351" target="_blank">
                            <img :src="'/imgs/ios-download-' + locale + '.webp'">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.airaffaires.pro" target="_blank">
                            <img :src="'/imgs/android-download-' + locale + '.webp'">
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-how-it-works-steps mobile-only">
            <h2>{{ $t('home.how-it-works') }}</h2>
            <div class="screens">
                <home-steps-screen-carousel :index="index" />
            </div>
            <DotNavigation :page-count="5" :value="index" @input="navigateTo($event)" />
            <div class="dot-navigation">
                <div v-for="i in 5" :key="i" @click="navigateTo(i)" :class="{active: i === index}" />
            </div>
            <carousel
                class="pills_carrousel"
                :autoplay="isVisible && autoplay"
                autoplay-hover-pause
                :autoplay-timeout="3000"
                :per-page="1"
                :pagination-enabled="false"
                center-mode
                loop
                @input="onCarouselInput($event)"
                :navigate-to="index - 1"
            >
                <slide v-for="i in 5" :key="i">
                    <div class="pills_container">
                        <div class="content" v-html="$t('home.how-it-works-'+i)"></div>
                    </div>
                </slide>
            </carousel>
            <div class="home-how-it-works-stores-container">
                <p>{{ $t('home.download-app') }}</p>
                <div class="home-how-it-works-stores">
                    <a href="https://apps.apple.com/us/app/openfly/id1450925351" target="_blank">
                        <img :src="'/imgs/ios-download-' + locale + '.webp'">
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.airaffaires.pro" target="_blank">
                        <img :src="'/imgs/android-download-' + locale + '.webp'">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import DotNavigation from './DotNavigation.vue';

export default {
    props: {
        locale: String,
    },
    components: {
        Carousel,
        Slide,
        DotNavigation,
    },
    data() {
        return {
            largeScreen: document.documentElement.clientWidth >= 768,
            index: 1,
            autoplay: true,
            isVisible: false,
        };
    },
    methods: {
        navigateTo(index) {
            this.autoplay = false;
            this.index = index;
        },
        onVisibilityChanged(isVisible) {
            this.isVisible = isVisible;
        },
        onCarouselInput(event) {
            this.index = typeof event == 'number' ? event + 1 : this.index;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "~styles/_variables";
.home-how-it-works-steps-container {
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 1023px) {
        padding: 50px 0px;
        width: 100%;
    }
    .home-how-it-works-steps {
        padding-top: 0;
        display: flex;
        align-items: start;
        @media screen and (max-width: 1023px) {
            flex-direction: column;
            align-items: center;
        }
        .screens,
        .pills {
            flex-basis: 50%;
        }
        .screens {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 50px;
            @media screen and (max-width: 1023px) {
                padding-right: 0px;
                justify-content: center;
            }
            img {
                height: 576px;
            }
            .VueCarousel-slide {
                display: flex;
                justify-content: center;
            }
        }
        .pills {
            // border-left: solid 1px;
            list-style: none;
            position: relative;
            padding-left: 15px;
            margin-left: 20px;
            li {
                line-height: 20px;
                margin: 25px;
                font-weight: bold;
                font-size: 14px;
                min-height: 60px;
                display: flex;
                cursor: pointer;
                @media (min-width: 768px) {
                    align-items: center;
                }
                span.step-label {
                    color: #91CCC7;
                    transition: color 0.5s ease;
                }
                span.order {
                    position: absolute;
                    left: -20px;
                    border: solid 1px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    font-size: 16px;
                    font-weight: bold;
                    background-color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    > span {
                        position: relative;
                        flex-grow: 1;
                        color: #A9B1C1;
                        transition: color 0.5s ease;
                    }
                }
                &.active {
                    span.step-label {
                        color: white;
                    }
                    span.order {
                        span {
                            color: $primary-color-dark;
                        }
                    }
                }
                &:not(:last-child) {
                    span.order::after {
                        content: ' ';
                        display: block;
                        width: 1px;
                        height: 75px;
                        background-color: white;
                        position: relative;
                        left: -50%;
                        top: 150%;
                    }
                }
            }
        }

        .pills_carrousel {
            max-width: calc(100vw);
            margin-top: 3px;
            .line {
                height: 5px;
                background: white;
                position: absolute;
                width: 100%;
                top: 57px;
            }
            .pills_container {
                display: flex;
                flex-direction: column;
                align-items: center;
                .pill {
                    background-color: white;
                    color: $primary-color-dark;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    z-index: 1;
                    margin: 40px 0;
                }
                .content {
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 30px;
                    padding: 0 20px;
                    text-align: center;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HomeStepsScreen.vue